import { JsonObject } from "json2typescript";
import { PortfolioDataInterface } from "../interfaces/portfolio-data.interface";

@JsonObject("PortfolioData")
export class PortfolioData implements PortfolioDataInterface {
    AdvisorCode?: string;
    AdvisorFullName?: string;
    AdvisoryModelId?: string;
    AdvisoryModelText?: string;
    Alias?: string;
    BenchmarkCodes?: string[];
    Clients?: Client[];
    Code?: string;
    Currency?: string;
    EndDate?: string;
    Id?: string;
    InitialDate?: string;
    IsFavourite?: boolean;
    IsGrouped?: boolean;
    MainBenchmarkId?: string;
    MainBenchmarkName?: string;
    ModelPortfolioId?: string;
    ModelPortfolioName?: string;
    Name?: string;
    NumPositions?: number;
    PerformanceBeetweenDates?: number;
    PerformanceBeetweenDatesAnualized?: number;
    PortfolioCode?: string;
    PortfolioType?: string;
    RiskLevel?: string;
    RiskProfileId?: string;
    RiskProfileName?: string;
    SameCode?: any;
    ServiceModelBehavior?: string;
    ServiceModelCode?: string;
    ServiceModelName?: string;
    TipoFotoCalc?: any;
    TotalEndDate?: string;
    TotalInitialDate?: string;
    TotalProfitLossBeetweenDates?: number;
    TotalProfitLossBeetweenDatesPercent?: number;
    UnrealizedGains?: number;
    UnrealizedGainsPercent?: number;
    Valuation?: number;
    Volatility?: number;
    ProfitLoss?: number;
    ProfitLossPercent?: number;
    AnalysisDate?: string;
    ValuationDate?: string;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}

@JsonObject("Client")
export class Client {
    ClientCode?: string;
    Code?: string;
    Id?: string;
    Name?: string;
    Number?: number;
    RelationTypeCode?: string;
    RelationTypeName?: string;
    SurName?: string;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}
